import type { Application } from '../types'

// Row highlight classes based on status
export const getRowHighlightClass = (status: Application['status']) => {
  switch (status) {
    case 'offer':
    case 'accepted':
      return 'border-l-2 border-l-emerald-500 bg-emerald-100/40 dark:bg-emerald-950/20'
    case 'hired':
      return 'border-l-2 border-l-sky-500 bg-sky-100/40 dark:bg-sky-950/20'
    case 'rejected':
    case 'ghosted':
    case 'withdrawn':
    case 'offer_declined':
      return 'border-l-2 border-l-slate-400 dark:border-l-slate-700 opacity-60'
    default:
      return ''
  }
}

// Truncate text with ellipsis
export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength).trim() + '…'
}
